export default __webpack_public_path__ + "static/media/product-detail-image-2.2dc7d7f9.svg";